var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[(_vm.icon)?_c('Icon',{staticClass:"mr-10 text-center text-black text-lg",class:[_vm.iconSet],attrs:{"title":_vm.$t(`common.icons.screen_reader_names.${_vm.icon}`),"iconClass":`fa-${_vm.icon}`}}):_vm._e(),_c('H2',{staticClass:"tracking-wide capitalize text-black"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }